import { ErrorHandler, Injectable } from '@angular/core';

import * as Sentry from '@sentry/browser';

import { environment } from '../environments/environment';

Sentry.init({
  dsn: environment['SENTRY_DSN'],
  enabled: !!environment['ENABLE_SENTRY'],
  environment: window.location.hostname
});

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor() { }

  handleError(error: any): void {
    const chunkFailedMessage: RegExp = new RegExp(/Loading chunk [\d]+ failed/);

    if (chunkFailedMessage.test(error.message)) {
      this.reloadPage();
    }

    if (!!environment['ENABLE_SENTRY']) {
      this.sendErrorsToSentry(error);
    }

    throw error;
  }

  private reloadPage(): void {
    window.location.reload();
  }

  private sendErrorsToSentry(error: any): void {
    Sentry.captureException(error.originalError || error);
  }
}
